export async function copyToClipboard(text: string): Promise<boolean> {
  if (!text) return false;

  if (navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(text);

      return true;
    } catch {}
  }

  try {
    const textarea = document.createElement('textarea');

    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();

    const ok = document.execCommand('copy');

    document.body.removeChild(textarea);

    return ok;
  } catch {
    return false;
  }
}

export async function shareOrCopy(
  data: ShareData,
): Promise<'shared' | 'copied' | 'failed'> {
  if (navigator.share) {
    try {
      await navigator.share(data);

      return 'shared';
    } catch (err: any) {
      // Usuário cancelou — não é falha real, mas não conseguimos compartilhar.
      if (err?.name === 'AbortError') return 'failed';
    }
  }

  const fallbackText = data.url || data.text || '';

  if (await copyToClipboard(fallbackText)) {
    return 'copied';
  }

  return 'failed';
}
